import { render, staticRenderFns } from "./PayrollOvertime.vue?vue&type=template&id=47bfe7fc&scoped=true&"
import script from "./PayrollOvertime.vue?vue&type=script&lang=js&"
export * from "./PayrollOvertime.vue?vue&type=script&lang=js&"
import style0 from "./PayrollOvertime.vue?vue&type=style&index=0&id=47bfe7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfe7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bfe7fc')) {
      api.createRecord('47bfe7fc', component.options)
    } else {
      api.reload('47bfe7fc', component.options)
    }
    module.hot.accept("./PayrollOvertime.vue?vue&type=template&id=47bfe7fc&scoped=true&", function () {
      api.rerender('47bfe7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollOvertime.vue"
export default component.exports